<template>
  <div>
    <div id="aboutPanel" class="grid-side-space tabcontent">
      <div class="content editorial">
       <h4 class="blueTitle">{{ $t("awardPage.title1") }}</h4>
        <br>
        <h4>{{ $t("awardPage.subtitle1") }}</h4><br>
        <p>{{ $t("awardPage.title1_text1") }}</p>
        <br><br>
        <h4 class="blueTitle">{{ $t("awardPage.title2") }}</h4><br>
        <h4>{{ $t("awardPage.subtitle2") }}</h4><br>
        <p>{{ $t("awardPage.title2_text1") }}</p>
        <h4>{{ $t("awardPage.subtitle3") }}</h4><br>
        <p>{{ $t("awardPage.title2_text2") }}</p>
        <h4>{{ $t("awardPage.subtitle4") }}</h4><br>
        <p>{{ $t("awardPage.title2_text3") }}</p>
        <h4>{{ $t("awardPage.subtitle5") }}</h4><br>
        <p>{{ $t("awardPage.title2_text4") }}</p>
        <h4>{{ $t("awardPage.subtitle6") }}</h4><br>
        <p>{{ $t("awardPage.title2_text5") }}</p>
        <p>{{ $t("awardPage.title2_text6") }}</p>
        <h4>{{ $t("awardPage.subtitle7") }}</h4><br>
        <p>{{ $t("awardPage.title2_text7") }}</p>
        <h4>{{ $t("awardPage.subtitle8") }}</h4><br>
        <p>{{ $t("awardPage.title2_text8") }}</p>

        <br><br>
        <h4 class="blueTitle">{{ $t("awardPage.title3") }}</h4><br>
        <h4>{{ $t("awardPage.subtitle9") }}</h4><br>
        <p>{{ $t("awardPage.title3_text1") }}</p>

        <br><br>
        <h4 class="blueTitle">{{ $t("awardPage.title4") }}</h4><br>
        <h4>{{ $t("awardPage.subtitle10") }}</h4><br>
        <p>{{ $t("awardPage.title4_text1") }}</p>
        <h4>{{ $t("awardPage.subtitle11") }}</h4><br>
        <p>{{ $t("awardPage.title4_text2") }}</p>
        <h4>{{ $t("awardPage.subtitle12") }}</h4><br>
        <p>{{ $t("awardPage.title4_text3") }}</p>
        <p>{{ $t("awardPage.title4_text4") }}</p>
        <h4>{{ $t("awardPage.subtitle13") }}</h4><br>
        <p>{{ $t("awardPage.title4_text5") }}</p>
        <h4>{{ $t("awardPage.subtitle14") }}</h4><br>
        <p>{{ $t("awardPage.title4_text6") }}</p>
        <h4>{{ $t("awardPage.subtitle15") }}</h4><br>
        <p>{{ $t("awardPage.title4_text7") }}</p>
        <ul>
          <li>{{ $t("awardPage.title4_text8") }}</li>
          <li>{{ $t("awardPage.title4_text9") }}</li>
          <li>{{ $t("awardPage.title4_text10") }}</li>
        </ul>
        <h4>{{ $t("awardPage.subtitle16") }}</h4><br>
        <p>{{ $t("awardPage.title4_text11") }}</p>

        <br><br>
        <h4 class="blueTitle">{{ $t("awardPage.title5") }}</h4><br>
        <h4>{{ $t("awardPage.subtitle17") }}</h4><br>
        <p>{{ $t("awardPage.title5_text1") }}</p>
        <h4>{{ $t("awardPage.subtitle18") }}</h4><br>
        <p>{{ $t("awardPage.title5_text2") }}</p>
        <h4>{{ $t("awardPage.subtitle19") }}</h4><br>
        <p>{{ $t("awardPage.title5_text3") }}</p>
        <h4>{{ $t("awardPage.subtitle20") }}</h4><br>
        <p>{{ $t("awardPage.title5_text4") }}</p>
        <h4>{{ $t("awardPage.subtitle21") }}</h4><br>
        <p>{{ $t("awardPage.title5_text5") }}</p>
        <h4>{{ $t("awardPage.subtitle22") }}</h4><br>
        <p>{{ $t("awardPage.title5_text6") }}</p>
        <h4>{{ $t("awardPage.subtitle23") }}</h4><br>
        <p>{{ $t("awardPage.title5_text7") }}</p>
        <h4>{{ $t("awardPage.subtitle24") }}</h4><br>
        <p>{{ $t("awardPage.title5_text8") }}</p>
        <p>{{ $t("awardPage.title5_text9") }}</p>

        <br><br>
        <h4 class="blueTitle">{{ $t("awardPage.title6") }}</h4><br>
        <h4>{{ $t("awardPage.subtitle25") }}</h4><br>
        <p>{{ $t("awardPage.title6_text1") }}</p>
        <h4>{{ $t("awardPage.subtitle26") }}</h4><br>
        <p>{{ $t("awardPage.title6_text2") }}</p>

        <br><br>
        <h4 class="blueTitle">{{ $t("awardPage.title7") }}</h4><br>
        <h4>{{ $t("awardPage.subtitle27") }}</h4><br>
        <p v-html="$t('awardPage.title7_text1')"></p>


      </div>

    </div>
  </div>
</template>
<script>
export default {

};
</script>


<style>
</style>